import SchoolLogo from "../../../schoolLogo.svg";
import ArrowForward from "../icons/arrow_forward.js";
import ArrowBack from "../icons/arrow_back.js";
import CloseX from "../icons/close_x.js";
import CheckBox from "../images/checkbox.webp";
import PrincipalImage from "../images/principal.webp";
import ParentingImage from "../images/parenting.png";
import NdliLogoLibrary from "../images/ndli-logo-lg-green.svg";
import WhatsappIcon from "../icons/whatsapp_logo.webp";
import ContactUsIcon from "../icons/contact_us.webp";
import MailIcon from "../icons/mail_icon.webp";

import WalkingDog from "../images/marqueeImages/WalkingDog.gif";
import WalkingDog2 from "../images/marqueeImages/WalkingDog2.gif";
import WalkingDog3 from "../images/marqueeImages/WalkingDog3.gif";
import WalkingFlamingo from "../images/marqueeImages/WalkingFlamingo.gif";
import WalkingPencil from "../images/marqueeImages/WalkingPencil.gif";

import PrincipalOffice from "../images/heroImages/principaloffice.webp";
import Janmashtmi from "../images/heroImages/janmashtmi.webp";
import KidsClass from "../images/heroImages/kidsclass.webp";
import Lab from "../images/heroImages/lab.webp";
import RepublicDay from "../images/heroImages/republicday.webp";
import KidsZone from "../images/heroImages/kidszone.webp";
import TheaterClass from "../images/heroImages/theaterclass.webp";
import YogaDay from "../images/heroImages/yogaday.webp";
import ArtClass from "../images/heroImages/artclass.webp";

import function1old from "../images/memoriesImages/function1old.webp";
import function2old from "../images/memoriesImages/function2old.webp";
import function3old from "../images/memoriesImages/function3old.webp";
import function4old from "../images/memoriesImages/function4old.webp";
import janmashtmiold from "../images/memoriesImages/janmashtmiold.webp";
import rallyold from "../images/memoriesImages/rallyold.webp";
import teachersdayold from "../images/memoriesImages/teachersdayold.webp";
import winnersold from "../images/memoriesImages/winnersold.webp";

import bhartiyabhashacamp from "../images/activityImages/bhartiyabhashacamp.webp";
import blockdaywithfirstclass from "../images/activityImages/blockdaywithfirstclass.webp";
import cardactivitylkg from "../images/activityImages/cardactivitylkg.webp";
import ganeshchaturthicelebration from "../images/activityImages/ganeshchaturthicelebration.webp";

export {
  SchoolLogo,
  ArrowForward,
  ArrowBack,
  CloseX,
  CheckBox,
  PrincipalImage,
  ParentingImage,
  NdliLogoLibrary,
  WhatsappIcon,
  ContactUsIcon,
  MailIcon,

  //Marquee Images
  WalkingDog,
  WalkingDog2,
  WalkingDog3,
  WalkingFlamingo,
  WalkingPencil,

  // Hero Images
  PrincipalOffice,
  Janmashtmi,
  KidsClass,
  Lab,
  RepublicDay,
  KidsZone,
  TheaterClass,
  YogaDay,
  ArtClass,

  // Memories Images
  function1old,
  function2old,
  function3old,
  function4old,
  janmashtmiold,
  rallyold,
  teachersdayold,
  winnersold,

  // Activity Images
  bhartiyabhashacamp,
  blockdaywithfirstclass,
  cardactivitylkg,
  ganeshchaturthicelebration,
};
